import Skeleton from '@pedidosya/web-fenix/system/Skeleton';

export const ProductCardSVerticalSkeleton = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      padding: '0 16px',
    }}
  >
    <div style={{ paddingBottom: 12 }}>
      <Skeleton borderRadiusSize="large" height="31.75" width="31.75" />
    </div>

    <div style={{ paddingBottom: 16 }}>
      <Skeleton
        borderRadiusSize="medium"
        height="shape-size-action-05"
        width="18.75"
      />
    </div>

    <div style={{ paddingBottom: 8 }}>
      <Skeleton
        borderRadiusSize="medium"
        height="shape-size-action-05"
        width="25.75"
      />
    </div>
    <Skeleton
      borderRadiusSize="medium"
      height="shape-size-action-05"
      width="shape-size-action-14"
    />
  </div>
);

export const ScrolleableProductCardSVerticalSkeleton = () => (
  <div
    style={{
      display: 'flex',
      overflow: 'hidden',
      overflowX: 'scroll',
      whiteSpace: 'nowrap',
      scrollbarWidth: 'none',
    }}
  >
    {[...Array(9)].map((index) => (
      <ProductCardSVerticalSkeleton key={index} />
    ))}
  </div>
);
